import { render, staticRenderFns } from "./ordersList.vue?vue&type=template&id=32a5e76c&scoped=true&"
import script from "./ordersList.vue?vue&type=script&lang=js&"
export * from "./ordersList.vue?vue&type=script&lang=js&"
import style0 from "./ordersList.vue?vue&type=style&index=0&id=32a5e76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a5e76c",
  null
  
)

export default component.exports